import React from 'react';
import { ChevronRight, Download, Receipt, Calendar, FileText, Loader2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { useTenant } from './TenantContext';

const TenantReceipts = () => {
  const { receipts, downloading, formatCurrency, formatDate, handleViewReceipt, handleDownloadReceiptPdf } = useTenant();
  return (
    <>
  <Card>
    <CardHeader>
      <CardTitle className="text-lg">Mes Quittances de Loyer</CardTitle>
    </CardHeader>
    <CardContent>
      {receipts.length > 0 ? (
        <div className="space-y-3">
          {receipts.map((receipt) => (
            <div
              key={receipt.id}
              className="flex items-center justify-between p-4 rounded-lg border border-gray-100 hover:bg-gray-50 transition-colors"
              data-testid={`receipt-item-${receipt.id}`}
            >
              <div 
                className="flex items-center gap-4 flex-1 cursor-pointer"
                onClick={() => handleViewReceipt(receipt)}
              >
                <div className="w-10 h-10 rounded-lg bg-[#D4A373]/10 flex items-center justify-center">
                  <FileText className="w-5 h-5 text-[#D4A373]" />
                </div>
                <div>
                  <p className="font-medium text-gray-900">
                    {formatCurrency(receipt.amount, receipt.currency)}
                  </p>
                  <div className="flex items-center gap-2 text-sm text-gray-500">
                    <Calendar className="w-3.5 h-3.5" />
                    <span>
                      {formatDate(receipt.period_start)} - {formatDate(receipt.period_end)}
                    </span>
                  </div>
                  <span className="text-xs font-mono text-gray-400">
                    {receipt.receipt_number}
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDownloadReceiptPdf(receipt.id, receipt.receipt_number);
                  }}
                  disabled={downloading === receipt.id}
                  data-testid={`download-receipt-${receipt.id}`}
                >
                  <Download className={`w-4 h-4 ${downloading === receipt.id ? 'animate-pulse' : ''}`} />
                  <span className="hidden sm:inline ml-2">PDF</span>
                </Button>
                <ChevronRight 
                  className="w-5 h-5 text-gray-400 cursor-pointer" 
                  onClick={() => handleViewReceipt(receipt)}
                />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-8">
          <Receipt className="w-12 h-12 mx-auto mb-3 text-gray-300" />
          <p className="text-gray-500">Aucune quittance disponible</p>
        </div>
      )}
    </CardContent>
  </Card>
    </>
  );
};

export default TenantReceipts;
